import React from "react";
import { Loader2 } from "lucide-react";

export function Loading({ label = "Loading…" }) {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-slate-400" data-testid="loading-indicator">
      <Loader2 className="h-8 w-8 animate-spin text-[#C86D51]" />
      <p className="mt-3 text-sm font-medium">{label}</p>
    </div>
  );
}

export function Empty({ icon: Icon, text }) {
  return (
    <div className="flex flex-col items-center justify-center py-14 text-center px-6" data-testid="empty-state">
      {Icon && <Icon className="h-10 w-10 text-slate-300 mb-3" />}
      <p className="text-slate-400 font-medium">{text}</p>
    </div>
  );
}
